import { render, staticRenderFns } from "./NotificationsDialog.vue?vue&type=template&id=1b635a3c&scoped=true&"
import script from "./NotificationsDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationsDialog.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsDialog.vue?vue&type=style&index=0&id=1b635a3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b635a3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VDivider,VPagination,VProgressLinear})
